import { QQ_SESSION_TYPE, QQ_CONNECT_SESSION_TYPE } from "../constants/langs"

export function loginStateUtil(loginStateParam = {}) {
  if (!loginStateParam) {
    return {}
  }
  let loginStateObj = {}
  const pskey = "pskey_"
  const uin = "uin"
  const skey = "skey"

  let { sessionId: session_id, sessionType: session_type } = loginStateParam
  // 兼容商店登录态写法
  session_id = session_id || loginStateParam.session_id || loginStateParam.sessionid
  session_type = (session_type || loginStateParam.session_type || loginStateParam.sessiontype)?.toLowerCase()

  // ------------------------------------------- QQ相关 --------------------------------------------------
  // skey 登录态类型
  loginStateObj.skey = session_id === uin && session_type === skey
  // pskey 登录态类型
  loginStateObj.pskey = session_id === uin && session_type && session_type.indexOf(pskey) > -1
  // qq互联登录态类型
  loginStateObj.qqConnect = QQ_CONNECT_SESSION_TYPE.indexOf(session_type) > -1

  // skey or pskey 登录态类型
  loginStateObj.skeyOrPskey = loginStateObj.skey || loginStateObj.pskey
  // 是QQ账户类型
  loginStateObj.isQQSessionType = QQ_SESSION_TYPE.indexOf(session_type) > -1 || loginStateObj.pskey

  // ------------------------------------------- WX相关 --------------------------------------------------

  return loginStateObj
}
